// extracted by mini-css-extract-plugin
export default {"info":"MCCSelection_info__kTI-H","shortcuts":"MCCSelection_shortcuts__hsqTT","shortcut":"MCCSelection_shortcut__G5OpE"};